import { IDocumentResource } from '../Resource/DocumentResource';
import { IBaseFault } from './BaseFault';

export enum FaultDefinitionCategory {
  None,
  Electrical,
  Mechanical,
  Communications,
  Environmental,
  Maintenance,
}

export const FaultDefinitionCategoryNames: {
  [key in FaultDefinitionCategory]: string;
} = {
  [FaultDefinitionCategory.None]: 'None',
  [FaultDefinitionCategory.Electrical]: 'Electrical',
  [FaultDefinitionCategory.Mechanical]: 'Mechanical',
  [FaultDefinitionCategory.Communications]: 'Communications',
  [FaultDefinitionCategory.Environmental]: 'Environmental',
  [FaultDefinitionCategory.Maintenance]: 'Maintenance',
};

export interface IFaultDefinitionFaultAction {
  faultActionId: string;
  // actionId: string; <- for use later
}

export interface IFaultDefinitionCreateRequest extends Omit<
  IFaultDefinition,
  | 'id'
  | 'createdOn'
  | 'createdBy'
  | 'updatedOn'
  | 'updatedBy'
  | 'deletedOn'
  | 'deletedBy'
  | 'type'
  | 'restore'
> {}

export interface IFaultDefinitionUpdateRequest extends Omit<
  IFaultDefinition,
  'createdOn' | 'createdBy' | 'deletedOn' | 'deletedBy' | 'type'
> {}

export interface IFaultDefinitionDeleteRequest extends Pick<
  IFaultDefinition,
  'id'
> {}

export interface IFaultDefinition extends IBaseFault {
  type: 'FaultDefinition';
  hardwareTypeId: string;
  hardwareManufacturerId: string;
  hardwareModelId: string;
  dataPointId: string;
  value: number;
  code: string;
  title: string;
  description: string;
  category: FaultDefinitionCategory;
  causes: string[];
  actions: IFaultDefinitionFaultAction[];
  resources: IDocumentResource[];
  restore?: boolean;
}
